import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'
import InactivityLogout from '@/pages/authentication/InactivityLogout.ts'
import AceLogo from '@assets/ace-pencil.png'

export const AuthLayout = ({ children }: ChildrenProp) => {
  return (
    <InactivityLogout>
      <div className="bg-muted-white flex flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        {children}
      </div>
      <div className="flex text-sm justify-center font-medium items-center gap-0.5 flex-col mb-2">
        <div className="flex items-center gap-2 text-sm">
          <img alt="Ace Logo" width="6" src={AceLogo} className="h-auto mb-1" />
          @ {new Date().getFullYear()} ACE Scholarships.
        </div>
        <div className="text-gray-400">Powered by SoftPoint LLC</div>
      </div>
    </InactivityLogout>
  )
}

type LayoutContentProps = { className?: string } & ChildrenProp
const LayoutContent = ({ children, className }: LayoutContentProps) => {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-[380px]">
      <div
        className={cn(
          'bg-white py-12 shadow-md border border-gray-50 sm:rounded-lg p-10',
          className
        )}
      >
        {children}
      </div>
    </div>
  )
}

AuthLayout.Content = LayoutContent
